import { Form, Formik, useFormikContext } from 'formik'
import type { FormikConfig } from 'formik'
import type { ReactElement } from 'react'
import { fromJS } from 'immutable'
import { useEffect } from 'react'

import { ProductLayout } from './ProductLayout'
import { ProductSelection } from './ProductSelection'
import Button from '../../../../formComponents/Button'
import ButtonRow from '../../../../formComponents/ButtonRow'

export function FormikOnChange<FormikValues>({ onChange }: Readonly<{ onChange: (vales: FormikValues) => void }>) {
  const { values } = useFormikContext<FormikValues>()
  useEffect(() => {
    onChange(values)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [values])

  return null
}

type ProductPluginData = {
  productId: string
  layout: 'simple' | 'detailed'
}

type Props = WorkspacePluginSettingsProps & TranslateProps
export default function ProductSettings({
  config,
  data,
  onCancel,
  onDataChange,
  onSave,
  renderLayout,
  t,
}: Props): ReactElement {
  const scopedT = (key: string, options?: any) => t(`settingsModal.${key}`, options)

  const formData = data.toJS() as ProductPluginData

  const title = scopedT('title')
  const body = (
    <div className="dali-settingslayer-main-content">
      <ProductSelection t={scopedT} config={config} />
      <ProductLayout t={scopedT} />
    </div>
  )

  const footer = (
    <ButtonRow>
      <Button variant="cancel" type="button" onClick={onCancel}>
        {scopedT('cancelButton.label')}
      </Button>
      <Button type="submit">{scopedT('saveButton.label')}</Button>
    </ButtonRow>
  )

  const handleSubmit: FormikConfig<ProductPluginData>['onSubmit'] = (values) => onSave(fromJS(values))
  const handleChange = (values: ProductPluginData) => onDataChange(fromJS(values))

  return (
    <Formik initialValues={formData} onSubmit={handleSubmit}>
      <Form translate="no">
        <FormikOnChange<ProductPluginData> onChange={handleChange} />
        {renderLayout({ title, body, footer })}
      </Form>
    </Formik>
  )
}
